import { AppState } from '../../reducers';
import { JiveEntity } from '../jiveEntities.model';

export const relationshipResourceSelector =
  (relationshipName: 'lineVoicemails' | 'entityPhoneNumbers') =>
  (state: AppState): JiveEntity<string[]> =>
    state.jiveEntities.relationships[relationshipName];
